'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = OnlinepbxButtonFill;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function OnlinepbxButtonFill(_ref) {
  var isGreen = _ref.isGreen,
      dataTest = _ref.dataTest,
      titleDisabled = _ref.titleDisabled,
      disabled = _ref.disabled,
      title = _ref.title,
      onClick = _ref.onClick,
      text = _ref.text,
      className = _ref.className,
      isWidth = _ref.isWidth,
      otherProps = _objectWithoutProperties(_ref, ['isGreen', 'dataTest', 'titleDisabled', 'disabled', 'title', 'onClick', 'text', 'className', 'isWidth']);

  return _react2['default'].createElement(
    'button',
    _extends({
      disabled: disabled,
      'data-test': dataTest,
      title: disabled ? titleDisabled : title,
      onClick: onClick,
      style: _extends({}, isWidth ? { width: '100%' } : {})
    }, otherProps, {
      className: (0, _classnames2['default'])('onlinepbx__lib__button__fill', className, {
        'onlinepbx__lib__button__fill__disabled': disabled,
        'onlinepbx__lib__button__fill__green': isGreen
      }) }),
    text
  );
}